import { render, staticRenderFns } from "./SrDesignEdit.vue?vue&type=template&id=32a40a46&"
import script from "./SrDesignEdit.vue?vue&type=script&lang=js&"
export * from "./SrDesignEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports